import React from 'react';
import ReactDOM from 'react-dom';
import './index.module.scss';
import App from './App';



ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);


const anchors = document.querySelectorAll('a[data-anchor]')
for (let anchor of anchors) {
  anchor.addEventListener('click', e=> { 
    e.preventDefault()
    let elem = document.querySelector(e.target.hash);

    const to = elem.offsetTop - 200;
    window.scrollTo({
      top: to,
      behavior: 'smooth'
    })
  })
}

